/* fix vh on iOS */
export const initViewHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const initViewHeightOnResize = () => {
    window.addEventListener('resize', initViewHeight);
};
